import { ChevronDown } from "lucide-react";

export const FIELD = "h-7 rounded-md border border-[#27324a] bg-[#0c1017] text-[11px] leading-none";

// A styled <select> that fills its share of a sidebar row: label on the left, value, chevron; amber when it is changing the cut.
export const Pick = ({ id, value, onChange, options, label, title, active, disabled }) => (
  <label className={`relative flex min-w-0 flex-1 items-center gap-2 pl-2.5 ${FIELD} ${active ? "border-[#f5a524]/70 bg-[#f5a524]/10 text-[#ffd27a]" : "text-[#e6e8ec]"} ${disabled ? "opacity-60" : "hover:border-[#3b4a6b]"}`} title={title}>
    <span className="pointer-events-none flex-none whitespace-nowrap text-[9px] uppercase tracking-wide text-[#6b7079]">{label}</span>
    <select data-testid={id} value={value} disabled={disabled} onChange={(e) => onChange(typeof options[0][0] === "number" ? Number(e.target.value) : e.target.value)}
      className="h-full min-w-0 flex-1 appearance-none bg-transparent pr-6 text-[11px] font-medium leading-none text-inherit focus:outline-none">
      {options.map(([v, text]) => <option key={v} value={v} className="bg-[#0c1017] text-[#e6e8ec]">{text}</option>)}
    </select>
    <ChevronDown className="pointer-events-none absolute right-2 h-3 w-3 text-[#6b7079]" />
  </label>
);
